import { ROLE_HIERARCHY } from '../constants'

import type { Role, UserWithAvatar } from '../types'
import type { UserResource } from '@clerk/shared/types'

/**
 * Get the user initials
 * @param user - The user
 * @returns The user initials
 */
export const getUserInitials = (user: UserWithAvatar | null) => {
	if (!user?.uname) return ''

	const email = user.uname || ''
	const name = email.split('@')[0]
	const last = name.split('.')[1]
	const initials = last ? name[0] + last[0] : name[0] + name[1]
	return initials.toUpperCase()
}

/**
 * Check if the user has the required role
 * @param userRole - The user's role
 * @param requiredRole - The required role
 * @returns True if the user has the required role, false otherwise
 */
export const hasRequiredRole = (
	userRole: Role | null | undefined,
	requiredRole: Role,
) => {
	if (!userRole) return false

	return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole]
}

/**
 * Check if user authenticated via SSO (OAuth or Enterprise SAML/OIDC)
 * @param user - The Clerk UserResource
 * @returns True if user has external (OAuth) or enterprise (SAML/OIDC) accounts
 */
export function isSSOUser(user: UserResource | null | undefined): boolean {
	if (!user) return false
	const hasOAuth = (user.externalAccounts?.length ?? 0) > 0
	const hasEnterprise = (user.enterpriseAccounts?.length ?? 0) > 0
	return hasOAuth || hasEnterprise
}
